import type { PropsWithChildren } from 'react';

import { ClientOnly } from 'remix-utils/client-only';

type Props = PropsWithChildren<{
  shouldRenderClientSide: boolean;
}>;

// A helper component to render if a library being utilized is not SSR compatible
// Example: EmblaCarousel https://www.embla-carousel.com/
const ClientSideRenderer = ({ shouldRenderClientSide, children }: Props) => {
  if (!shouldRenderClientSide) {
    return <>{children}</>;
  }

  return <ClientOnly fallback={null}>{() => children}</ClientOnly>;
};

export default ClientSideRenderer;
